/**
 * transcriptConfidence.ts — vanaf welke zekerheid noemen we een transcript giswerk?
 *
 * De transcriptiemodellen geven een gemiddelde log-waarschijnlijkheid terug: 0 is zeker, hoe
 * negatiever hoe meer het model zat te raden. Die schaal is NIET gelijk per model, en dat is
 * gemeten, niet aangenomen: op dezelfde opnamen zit whisper-1 structureel lager dan de
 * gpt-4o-modellen. Eén drempel voor alle drie keurt dus of te veel af, of niets.
 *
 * Deze grenzen staan hier en niet in de backend, omdat /admin/analysis ze óók nodig heeft: een
 * zekerheid van -0,6 is zonder de grens van zijn model geen informatie. Twee kopieën zouden
 * stilletjes uit elkaar lopen en dan toont de pagina iets anders dan de backend besliste.
 *
 * ZE ZIJN NOG NIET GEIJKT op genoeg opnamen. Eén meting is bekend: een vloeiend transcript in de
 * verkeerde taal kwam binnen op -0,007 -- het model was volkomen zeker van iets dat volledig mis
 * was. Daarom hangt de taalcontrole er los naast; deze grens vangt dat geval nooit.
 */

/** De grens per model. Daaronder beschouwen we het transcript als giswerk. */
export const LOGPROB_THRESHOLDS: Record<string, number> = {
  'whisper-1': -0.8,
  'gpt-4o-transcribe': -0.5,
  'gpt-4o-mini-transcribe': -0.5,
};

/** De grens van een model; een onbekend model krijgt de voorzichtigste (laagste). */
export function logprobThreshold(model?: string | null): number {
  const bekend = model ? LOGPROB_THRESHOLDS[model] : undefined;
  return bekend ?? Math.min(...Object.values(LOGPROB_THRESHOLDS));
}
